import React from 'react';

import { Button, Paper, Tab, Tabs, Typography } from '@mui/material';

import FieldGrid from '../../shared/FieldGrid';
import ReadOnlyField from '../../shared/ReadOnlyField';
import TabPanelShell from '../../shared/TabPanelShell';

import { OPPORTUNITY_INFO_FIELDS } from './detailsFields';
import { DETAIL_SECTIONS, type DetailSectionId, getDetailSection } from './types';

interface Props {
  activeSectionId: DetailSectionId;
  onSectionChange: (sectionId: DetailSectionId) => void;
}

export default function DetailsTab({ activeSectionId, onSectionChange }: Props) {
  const activeSection = getDetailSection(activeSectionId);

  return (
    <TabPanelShell
      title="Details"
      subtitle="Opportunity fields from Salesforce, arranged for review in Offer Builder."
      actions={
        <Button disabled size="small" variant="outlined">
          Open in Salesforce
        </Button>
      }
    >
      <Tabs
        allowScrollButtonsMobile
        scrollButtons="auto"
        value={activeSectionId}
        variant="scrollable"
        sx={{ mb: 3 }}
        onChange={(_event, value: DetailSectionId) => onSectionChange(value)}
      >
        {DETAIL_SECTIONS.map((section) => (
          <Tab key={section.id} label={section.label} value={section.id} />
        ))}
      </Tabs>

      {activeSectionId === 'opportunity-info' ? (
        <FieldGrid>
          {OPPORTUNITY_INFO_FIELDS.map((field) => (
            <ReadOnlyField key={field.label} field={field} />
          ))}
        </FieldGrid>
      ) : (
        <Paper variant="outlined" sx={{ p: 3 }}>
          <Typography variant="h6">{activeSection?.label}</Typography>
        </Paper>
      )}
    </TabPanelShell>
  );
}
